import { render } from "./Sectores.vue?vue&type=template&id=21eb78cf&scoped=true"
import script from "./Sectores.vue?vue&type=script&lang=js"
export * from "./Sectores.vue?vue&type=script&lang=js"

import "./Sectores.vue?vue&type=style&index=0&id=21eb78cf&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21eb78cf"]])

export default __exports__